import React from "react";
import { WhatsappLogo, MessengerLogo, InstagramLogo, Globe, EnvelopeSimple } from "@phosphor-icons/react";

const ORIGINS = {
  whatsapp: { label: "WhatsApp", Icon: WhatsappLogo, cls: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" },
  messenger: { label: "Messenger", Icon: MessengerLogo, cls: "bg-blue-500/10 text-blue-700 border-blue-500/30" },
  instagram: { label: "Instagram", Icon: InstagramLogo, cls: "bg-pink-500/10 text-pink-700 border-pink-500/30" },
  web: { label: "Web", Icon: Globe, cls: "bg-slate-500/10 text-slate-700 border-slate-500/30" },
  email: { label: "Email", Icon: EnvelopeSimple, cls: "bg-amber-500/10 text-amber-700 border-amber-500/30" },
};

export const OriginBadge = ({ channel, testid }) => {
  const o = ORIGINS[channel];
  if (!o) return null;
  const { Icon } = o;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-[10px] font-medium ${o.cls}`}
      title={`Primer contacto por ${o.label}`}
      data-testid={testid}
    >
      <Icon size={11} weight="fill" /> {o.label}
    </span>
  );
};

export default OriginBadge;
